import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (DetailsCard) code-splits into
// its own tpl-details-card chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'details-card',
    name: 'Details Card',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-details-card" */ "./DetailsCard")),
    description: 'Details card'
})
